export enum ActionsEnum {
    Categories="categories",
    Seo="seo",
    Config="config",
    Pages="pages",
    Users="users",
    UsersSanitized="usersSanitized",
    CategoryShow="categoryShow",
    Slider="slider",
    Banner="banner",
    Images="image",
    Comments="comments",



}